import React, { useEffect, useState, useContext } from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";

import useSettings from "../../hooks/useSettings";

import { makeStyles } from "@material-ui/core/styles";

import { TextField, InputAdornment, Typography } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import AccessTime from "@material-ui/icons/AccessTime";
import CallOutlined from "@material-ui/icons/CallOutlined";
import ChatBubbleOutline from "@material-ui/icons/ChatBubbleOutline";
import CheckCircleOutline from "@material-ui/icons/CheckCircleOutline";
import ConfirmationNumberOutlined from "@material-ui/icons/ConfirmationNumberOutlined";
import CreateOutlined from "@material-ui/icons/CreateOutlined";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import DescriptionOutlined from "@material-ui/icons/DescriptionOutlined";
import FormatListNumbered from "@material-ui/icons/FormatListNumbered";
import ForumOutlined from "@material-ui/icons/ForumOutlined";
import HeadsetMicOutlined from "@material-ui/icons/HeadsetMicOutlined";
import HowToReg from "@material-ui/icons/HowToReg";
import Link from "@material-ui/icons/Link";
import LocalOfferOutlined from "@material-ui/icons/LocalOfferOutlined";
import Memory from "@material-ui/icons/Memory";
import MicNone from "@material-ui/icons/MicNone";
import NotificationsNone from "@material-ui/icons/NotificationsNone";
import PeopleOutline from "@material-ui/icons/PeopleOutline";
import PhoneOutlined from "@material-ui/icons/PhoneOutlined";
import Security from "@material-ui/icons/Security";
import SettingsOutlined from "@material-ui/icons/SettingsOutlined";
import Shuffle from "@material-ui/icons/Shuffle";
import StarBorder from "@material-ui/icons/StarBorder";
import SwapHoriz from "@material-ui/icons/SwapHoriz";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { i18n } from "../../translate/i18n";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  selectContainer: { width: "100%", textAlign: "left" },
  shell: {
    display: "flex", minHeight: 570, gap: 22, alignItems: "stretch",
    color: theme.palette.text.primary,
    "@media (max-width: 900px)": { flexDirection: "column", gap: 12 },
  },
  sidebar: {
    width: 258, flexShrink: 0, padding: 10, background: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`, borderRadius: 14,
    "@media (max-width: 900px)": {
      width: "100%", display: "flex", overflowX: "auto", gap: 5, padding: 8,
    },
  },
  sideItem: {
    display: "flex", alignItems: "center", gap: 12, width: "100%", border: "none",
    borderLeft: "3px solid transparent", background: "transparent", color: theme.palette.text.primary,
    textAlign: "left", cursor: "pointer", borderRadius: 9, padding: "13px 11px", marginBottom: 4,
    transition: "background .18s, color .18s", fontFamily: "inherit",
    "&:hover": { background: theme.palette.action.hover },
    "&:focus-visible": { outline: "2px solid #2563eb", outlineOffset: -2 },
    "@media (max-width: 900px)": { flexShrink: 0, width: "auto", marginBottom: 0, padding: "10px 14px" },
  },
  sideActive: {
    background: theme.palette.type === "dark" ? "rgba(48,107,240,.18)" : "#eaf2ff",
    borderLeftColor: "#1555e8", color: theme.palette.type === "dark" ? "#93b7ff" : "#0645d0",
    fontWeight: 700,
  },
  sideIcon: { width: 23, height: 23, flexShrink: 0, fontSize: "22px !important" },
  sideTitle: { display: "block", fontSize: 13, lineHeight: 1.35, fontWeight: 600, whiteSpace: "nowrap" },
  sideSub: { display: "block", fontSize: 11, opacity: .65, marginTop: 2, "@media (max-width: 900px)": { display: "none" } },
  body: { minWidth: 0, flex: 1 },
  toolbar: {
    display: "flex", alignItems: "center", gap: 16, justifyContent: "space-between",
    padding: "2px 0 15px", flexWrap: "wrap",
  },
  sectionName: { fontWeight: 750, color: theme.palette.text.primary, fontSize: 22, lineHeight: 1.15 },
  sectionHint: { fontSize: 12, color: theme.palette.text.secondary, marginTop: 5 },
  search: {
    width: 300, maxWidth: "100%",
    "& .MuiOutlinedInput-root": { background: theme.palette.background.paper, borderRadius: 10, fontSize: 13, height: 43 },
    "@media (max-width: 600px)": { width: "100%" },
  },
  info: {
    display: "flex", alignItems: "center", gap: 7, color: theme.palette.text.secondary,
    fontSize: 12, paddingBottom: 15,
  },
  grid: { display: "grid", gridTemplateColumns: "repeat(3, minmax(0, 1fr))", gap: 12,
    "@media (max-width: 1400px)": { gridTemplateColumns: "repeat(2, minmax(0, 1fr))" },
    "@media (max-width: 730px)": { gridTemplateColumns: "1fr" },
  },
  card: {
    background: theme.palette.background.paper, border: `1px solid ${theme.palette.divider}`,
    borderRadius: 13, padding: "16px 15px 13px", display: "flex", flexDirection: "column",
    minHeight: 170, boxSizing: "border-box", boxShadow: theme.palette.type === "dark" ? "none" : "0 5px 20px rgba(20,39,86,.035)",
    transition: "border-color .18s, box-shadow .18s",
    "&:focus-within": { borderColor: "#7eabfb", boxShadow: "0 4px 18px rgba(28,90,217,.085)" },
  },
  cardHead: { display: "flex", gap: 12, alignItems: "flex-start", flexGrow: 1, paddingBottom: 15 },
  iconFrame: {
    background: theme.palette.type === "dark" ? "rgba(37,99,235,.20)" : "#ecf3ff",
    color: theme.palette.type === "dark" ? "#a7c4ff" : "#1e57cf", borderRadius: 11,
    flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", height: 42, width: 42,
  },
  fieldTitle: { fontSize: 13, fontWeight: 700, lineHeight: 1.35, marginBottom: 5 },
  fieldSubtitle: { color: theme.palette.text.secondary, fontSize: 11.5, lineHeight: 1.45 },
  control: {
    width: "100%",
    "& .MuiFormControl-root": { width: "100%" },
    "& .MuiFormControl-root > .MuiInputLabel-root": { position: "absolute", width: 1, height: 1, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", border: 0 },
    "& .MuiInputBase-root:not(.MuiOutlinedInput-root)": { border: `1px solid ${theme.palette.divider}`, borderRadius: 8, background: theme.palette.background.default, padding: "0 9px", minHeight: 40, fontSize: 13 },
    "& .MuiInputBase-root:not(.MuiOutlinedInput-root):before, & .MuiInputBase-root:not(.MuiOutlinedInput-root):after": { display: "none" },
    "& .MuiSelect-root": { padding: "10px 23px 10px 4px", minHeight: "20px", boxSizing: "border-box", whiteSpace: "normal" },
    "& .MuiFormHelperText-root": { margin: "6px 2px 0", fontSize: 10.5, lineHeight: 1.3 },
    "& .MuiOutlinedInput-root": { borderRadius: 8, background: theme.palette.background.default, fontSize: 13 },
    "& .MuiTextField-root .MuiInputLabel-root": { fontSize: 13 },
    "& textarea": { fontSize: 13, lineHeight: 1.45 },
  },
  footer: {
    display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 8,
    color: theme.palette.text.secondary, fontSize: 12, padding: "16px 0 2px",
  },
  empty: { padding: 36, border: `1px dashed ${theme.palette.divider}`, borderRadius: 13, textAlign: "center", color: theme.palette.text.secondary },
}));

const SETTINGS_CATEGORIES = [
  { id: "geral", title: "Geral", description: "Configurações principais", icon: "SettingsOutlined" },
  { id: "atendimento", title: "Atendimento", description: "Distribuição e avaliações", icon: "HeadsetMicOutlined" },
  { id: "automaticas", title: "Mensagens automáticas", description: "Saudações e respostas", icon: "ChatBubbleOutline" },
  { id: "chamadas", title: "Chamadas e WhatsApp", description: "Áudio e ligações", icon: "PhoneOutlined" },
  { id: "fila", title: "Filas de espera", description: "Mensagens e posição", icon: "FormatListNumbered" },
  { id: "tickets", title: "Tickets e encerramento", description: "Transferências e etiquetas", icon: "ConfirmationNumberOutlined" },
  { id: "expediente", title: "Expediente", description: "Horário de funcionamento", icon: "AccessTime" },
  { id: "notificacoes", title: "Notificações", description: "Alertas e pendências", icon: "NotificationsNone" },
  { id: "personalizadas", title: "Mensagens personalizadas", description: "Textos dos atendimentos", icon: "DescriptionOutlined" },
  { id: "lgpd", title: "Privacidade / LGPD", description: "Proteção de dados", icon: "Security" },
];

const SETTING_ICONS = { AccessTime, CallOutlined, ChatBubbleOutline, CheckCircleOutline, ConfirmationNumberOutlined, CreateOutlined, DeleteOutline, DescriptionOutlined, FormatListNumbered, ForumOutlined, HeadsetMicOutlined, HowToReg, Link, LocalOfferOutlined, Memory, MicNone, NotificationsNone, PeopleOutline, PhoneOutlined, Security, SettingsOutlined, Shuffle, StarBorder, SwapHoriz, VisibilityOff };
const SettingIcon = ({ name, className }) => {
  const IconComponent = SETTING_ICONS[name] || SettingsOutlined;
  return <IconComponent className={className} />;
};

export default function Options(props) {
  const { oldSettings, settings, scheduleTypeChanged, user } = props;

  const classes = useStyles();
  const [userRating, setUserRating] = useState("disabled");
  const [scheduleType, setScheduleType] = useState("disabled");
  const [chatBotType, setChatBotType] = useState("text");

  const [loadingUserRating, setLoadingUserRating] = useState(false);
  const [loadingScheduleType, setLoadingScheduleType] = useState(false);

  const [userCreation, setUserCreation] = useState("disabled");
  const [loadingUserCreation, setLoadingUserCreation] = useState(false);

  const [SendGreetingAccepted, setSendGreetingAccepted] = useState("enabled");
  const [loadingSendGreetingAccepted, setLoadingSendGreetingAccepted] = useState(false);

  const [UserRandom, setUserRandom] = useState("enabled");
  const [loadingUserRandom, setLoadingUserRandom] = useState(false);

  const [SettingsTransfTicket, setSettingsTransfTicket] = useState("enabled");
  const [loadingSettingsTransfTicket, setLoadingSettingsTransfTicket] = useState(false);

  const [AcceptCallWhatsapp, setAcceptCallWhatsapp] = useState("enabled");
  const [loadingAcceptCallWhatsapp, setLoadingAcceptCallWhatsapp] = useState(false);

  const [sendSignMessage, setSendSignMessage] = useState("enabled");
  const [loadingSendSignMessage, setLoadingSendSignMessage] = useState(false);

  const [sendGreetingMessageOneQueues, setSendGreetingMessageOneQueues] = useState("enabled");
  const [loadingSendGreetingMessageOneQueues, setLoadingSendGreetingMessageOneQueues] = useState(false);

  const [sendQueuePosition, setSendQueuePosition] = useState("enabled");
  const [loadingSendQueuePosition, setLoadingSendQueuePosition] = useState(false);

  const [sendFarewellWaitingTicket, setSendFarewellWaitingTicket] = useState("enabled");
  const [loadingSendFarewellWaitingTicket, setLoadingSendFarewellWaitingTicket] = useState(false);

  const [acceptAudioMessageContact, setAcceptAudioMessageContact] = useState("enabled");
  const [loadingAcceptAudioMessageContact, setLoadingAcceptAudioMessageContact] = useState(false);

  //LGPD
  const [enableLGPD, setEnableLGPD] = useState("disabled");
  const [loadingEnableLGPD, setLoadingEnableLGPD] = useState(false);

  const [lgpdMessage, setLGPDMessage] = useState("");
  const [loadinglgpdMessage, setLoadingLGPDMessage] = useState(false);

  const [lgpdLink, setLGPDLink] = useState("");
  const [loadingLGPDLink, setLoadingLGPDLink] = useState(false);

  const [lgpdDeleteMessage, setLGPDDeleteMessage] = useState("disabled");
  const [loadingLGPDDeleteMessage, setLoadingLGPDDeleteMessage] = useState(false);

  const [lgpdConsent, setLGPDConsent] = useState("disabled");
  const [loadingLGPDConsent, setLoadingLGPDConsent] = useState(false);

  const [lgpdHideNumber, setLGPDHideNumber] = useState("disabled");
  const [loadingLGPDHideNumber, setLoadingLGPDHideNumber] = useState(false);

  // Tag obrigatoria
  const [requiredTag, setRequiredTag] = useState("enabled")
  const [loadingRequiredTag, setLoadingRequiredTag] = useState(false)

  // Fechar ticket ao transferir para outro setor
  const [closeTicketOnTransfer, setCloseTicketOnTransfer] = useState(false)
  const [loadingCloseTicketOnTransfer, setLoadingCloseTicketOnTransfer] = useState(false)

  // Usar carteira de clientes
  const [directTicketsToWallets, setDirectTicketsToWallets] = useState(false)
  const [loadingDirectTicketsToWallets, setLoadingDirectTicketsToWallets] = useState(false)

  //MENSAGENS CUSTOMIZADAS
  const [transferMessage, setTransferMessage] = useState("");
  const [loadingTransferMessage, setLoadingTransferMessage] = useState(false);

  const [greetingAcceptedMessage, setGreetingAcceptedMessage] = useState("");
  const [loadingGreetingAcceptedMessage, setLoadingGreetingAcceptedMessage] = useState(false);
  
  const [AcceptCallWhatsappMessage, setAcceptCallWhatsappMessage] = useState("");
  const [loadingAcceptCallWhatsappMessage, setLoadingAcceptCallWhatsappMessage] = useState(false);

  const [sendQueuePositionMessage, setSendQueuePositionMessage] = useState("");
  const [loadingSendQueuePositionMessage, setLoadingSendQueuePositionMessage] = useState(false);

  const [showNotificationPending, setShowNotificationPending] = useState(false);
  const [loadingShowNotificationPending, setLoadingShowNotificationPending] = useState(false);

  const { update: updateUserCreation, getAll } = useSettings();

  const { update } = useCompanySettings();

  const isSuper = () => {
    return user.super;
  };


  useEffect(() => {

    if (Array.isArray(oldSettings) && oldSettings.length) {

      const userPar = oldSettings.find((s) => s.key === "userCreation");

      if (userPar) {
        setUserCreation(userPar.value);
      }
    }
  }, [oldSettings])


  useEffect(() => {
    for (const [key, value] of Object.entries(settings)) {
      if (key === "userRating") setUserRating(value);
      if (key === "scheduleType") setScheduleType(value);
      if (key === "chatBotType") setChatBotType(value);
      if (key === "acceptCallWhatsapp") setAcceptCallWhatsapp(value);
      if (key === "userRandom") setUserRandom(value);
      if (key === "sendGreetingMessageOneQueues") setSendGreetingMessageOneQueues(value);
      if (key === "sendSignMessage") setSendSignMessage(value);
      if (key === "sendFarewellWaitingTicket") setSendFarewellWaitingTicket(value);
      if (key === "sendGreetingAccepted") setSendGreetingAccepted(value);
      if (key === "sendQueuePosition") setSendQueuePosition(value);
      if (key === "acceptAudioMessageContact") setAcceptAudioMessageContact(value);
      if (key === "enableLGPD") setEnableLGPD(value);
      if (key === "requiredTag") setRequiredTag(value);
      if (key === "lgpdDeleteMessage") setLGPDDeleteMessage(value)
      if (key === "lgpdHideNumber") setLGPDHideNumber(value);
      if (key === "lgpdConsent") setLGPDConsent(value);
      if (key === "lgpdMessage") setLGPDMessage(value);
      if (key === "sendMsgTransfTicket") setSettingsTransfTicket(value);
      if (key === "lgpdLink") setLGPDLink(value);
      if (key === "DirectTicketsToWallets") setDirectTicketsToWallets(value);
      if (key === "closeTicketOnTransfer") setCloseTicketOnTransfer(value);
      if (key === "transferMessage") setTransferMessage(value);
      if (key === "greetingAcceptedMessage") setGreetingAcceptedMessage(value);
      if (key === "AcceptCallWhatsappMessage") setAcceptCallWhatsappMessage(value);
      if (key === "sendQueuePositionMessage") setSendQueuePositionMessage(value);
      if (key === "showNotificationPending") setShowNotificationPending(value);

    }
  }, [settings]);

  async function handleChangeUserCreation(value) {
    setUserCreation(value);
    setLoadingUserCreation(true);
    await updateUserCreation({
      key: "userCreation",
      value,
    });
    setLoadingUserCreation(false);
  }

  async function handleChangeUserRating(value) {
    setUserRating(value);
    setLoadingUserRating(true);
    await update({
      column: "userRating",
      data: value
    });
    setLoadingUserRating(false);
  }

  async function handleScheduleType(value) {
    setScheduleType(value);
    setLoadingScheduleType(true);
    await update({
      column: "scheduleType",
      data: value
    });
    setLoadingScheduleType(false);
    if (typeof scheduleTypeChanged === "function") {
      scheduleTypeChanged(value);
    }
  }

  async function handleChatBotType(value) {
    setChatBotType(value);
    await update({
      column: "chatBotType",
      data: value
    });
    if (typeof scheduleTypeChanged === "function") {
      setChatBotType(value);
    }
  }

  async function handleLGPDMessage(value) {
    setLGPDMessage(value);
    setLoadingLGPDMessage(true);
    await update({
      column: "lgpdMessage",
      data: value
    });
    setLoadingLGPDMessage(false);
  }

  async function handletransferMessage(value) {
    setTransferMessage(value);
    setLoadingTransferMessage(true);
    await update({
      column: "transferMessage",
      data: value
    });
    setLoadingTransferMessage(false);
  }

  async function handleGreetingAcceptedMessage(value) {
    setGreetingAcceptedMessage(value);
    setLoadingGreetingAcceptedMessage(true);
    await update({
      column: "greetingAcceptedMessage",
      data: value
    });
    setLoadingGreetingAcceptedMessage(false);
  }

  async function handleAcceptCallWhatsappMessage(value) {
    setLoadingAcceptCallWhatsappMessage(true);
    try {
      const result = await update({ column: "AcceptCallWhatsappMessage", data: value });
      if (result.pendingConnections && result.pendingConnections.length) {
        toast.warn("Mensagem salva, mas algumas conexões não sincronizaram. Verifique a Evolution API.");
      }
    } catch (error) {
      toast.error(error.response?.data?.error || "Não foi possível salvar a mensagem de chamadas.");
    } finally {
      setLoadingAcceptCallWhatsappMessage(false);
    }
  }

  async function handlesendQueuePositionMessage(value) {
    setSendQueuePositionMessage(value);
    setLoadingSendQueuePositionMessage(true);
    await update({
      column: "sendQueuePositionMessage",
      data: value
    });
    setLoadingSendQueuePositionMessage(false);
  }

  async function handleShowNotificationPending(value) {
    setShowNotificationPending(value);
    setLoadingShowNotificationPending(true);
    await update({
      column: "showNotificationPending",
      data: value
    });
    setLoadingShowNotificationPending(false);
  }

  async function handleLGPDLink(value) {
    setLGPDLink(value);
    setLoadingLGPDLink(true);
    await update({
      column: "lgpdLink",
      data: value
    });
    setLoadingLGPDLink(false);
  }

  async function handleLGPDDeleteMessage(value) {
    setLGPDDeleteMessage(value);
    setLoadingLGPDDeleteMessage(true);
    await update({
      column: "lgpdDeleteMessage",
      data: value
    });
    setLoadingLGPDDeleteMessage(false);
  }

  async function handleLGPDConsent(value) {
    setLGPDConsent(value);
    setLoadingLGPDConsent(true);
    await update({
      column: "lgpdConsent",
      data: value
    });
    setLoadingLGPDConsent(false);
  }

  async function handleLGPDHideNumber(value) {
    setLGPDHideNumber(value);
    setLoadingLGPDHideNumber(true);
    await update({
      column: "lgpdHideNumber",
      data: value
    });
    setLoadingLGPDHideNumber(false);
  }

  async function handleSendGreetingAccepted(value) {
    setSendGreetingAccepted(value);
    setLoadingSendGreetingAccepted(true);
    await update({
      column: "sendGreetingAccepted",
      data: value
    });
    setLoadingSendGreetingAccepted(false);
  }

  async function handleUserRandom(value) {
    setUserRandom(value);
    setLoadingUserRandom(true);
    await update({
      column: "userRandom",
      data: value
    });
    setLoadingUserRandom(false);
  }

  async function handleSettingsTransfTicket(value) {
    setSettingsTransfTicket(value);
    setLoadingSettingsTransfTicket(true);
    await update({
      column: "sendMsgTransfTicket",
      data: value
    });
    setLoadingSettingsTransfTicket(false);
  }

  async function handleAcceptCallWhatsapp(value) {
    setLoadingAcceptCallWhatsapp(true);
    try {
      // Se o usuário digitou a mensagem e selecionou o modo imediatamente,
      // persiste primeiro o texto para evitar a corrida entre blur e select.
      if (value === "reject_message" &&
          AcceptCallWhatsappMessage !== (settings.AcceptCallWhatsappMessage || "")) {
        await update({ column: "AcceptCallWhatsappMessage", data: AcceptCallWhatsappMessage });
      }
      const result = await update({ column: "acceptCallWhatsapp", data: value });
      setAcceptCallWhatsapp(value);
      if (result.pendingConnections && result.pendingConnections.length) {
        toast.warn("Opção salva, mas algumas conexões não sincronizaram. Verifique a Evolution API.");
      }
    } catch (error) {
      toast.error(error.response?.data?.error || "Não foi possível alterar o tratamento de chamadas.");
    } finally {
      setLoadingAcceptCallWhatsapp(false);
    }
  }

  async function handleSendSignMessage(value) {
    setSendSignMessage(value);
    setLoadingSendSignMessage(true);
    await update({
      column: "sendSignMessage",
      data: value
    });
    localStorage.setItem("sendSignMessage", value === "enabled" ? true : false); //atualiza localstorage para sessão
    setLoadingSendSignMessage(false);
  }

  async function handleSendGreetingMessageOneQueues(value) {
    setSendGreetingMessageOneQueues(value);
    setLoadingSendGreetingMessageOneQueues(true);
    await update({
      column: "sendGreetingMessageOneQueues",
      data: value
    });
    setLoadingSendGreetingMessageOneQueues(false);
  }

  async function handleSendQueuePosition(value) {
    setSendQueuePosition(value);
    setLoadingSendQueuePosition(true);
    await update({
      column: "sendQueuePosition",
      data: value
    });
    setLoadingSendQueuePosition(false);
  }

  async function handleSendFarewellWaitingTicket(value) {
    setSendFarewellWaitingTicket(value);
    setLoadingSendFarewellWaitingTicket(true);
    await update({
      column: "sendFarewellWaitingTicket",
      data: value
    });
    setLoadingSendFarewellWaitingTicket(false);
  }

  async function handleAcceptAudioMessageContact(value) {
    setAcceptAudioMessageContact(value);
    setLoadingAcceptAudioMessageContact(true);
    await update({
      column: "acceptAudioMessageContact",
      data: value
    });
    setLoadingAcceptAudioMessageContact(false);
  }

  async function handleEnableLGPD(value) {
    setEnableLGPD(value);
    setLoadingEnableLGPD(true);
    await update({
      column: "enableLGPD",
      data: value
    });
    setLoadingEnableLGPD(false);
  }

  async function handleRequiredTag(value) {
    setRequiredTag(value);
    setLoadingRequiredTag(true);
    await update({
      column: "requiredTag",
      data: value,
    });
    setLoadingRequiredTag(false);
  }

  async function handleCloseTicketOnTransfer(value) {
    setCloseTicketOnTransfer(value);
    setLoadingCloseTicketOnTransfer(true);
    await update({
      column: "closeTicketOnTransfer",
      data: value,
    });
    setLoadingCloseTicketOnTransfer(false);
  }

  async function handleDirectTicketsToWallets(value) {
    setDirectTicketsToWallets(value);
    setLoadingDirectTicketsToWallets(true);
    await update({
      column: "DirectTicketsToWallets",
      data: value,
    });
    setLoadingDirectTicketsToWallets(false);
  }

  const [selectedCategory, setSelectedCategory] = useState("geral");
  const [searchTerm, setSearchTerm] = useState("");
  const normalizedTerm = searchTerm.trim().toLocaleLowerCase("pt-BR");
  const availableCategories = SETTINGS_CATEGORIES.filter((category) => category.id !== "lgpd" || enableLGPD === "enabled");
  const category = SETTINGS_CATEGORIES.find((item) => item.id === selectedCategory) || SETTINGS_CATEGORIES[0];
  const allFields = [
{ id: "creation", group: "geral", title: "Criação de empresas e usuários", description: "Permite habilitar ou bloquear novos cadastros na plataforma.", icon: "PeopleOutline", visible: isSuper(), field: (
<FormControl className={classes.selectContainer}>
              <InputLabel id="UserCreation-label">
                {i18n.t("settings.settings.options.creationCompanyUser")}
              </InputLabel>
              <Select
                labelId="UserCreation-label"
                value={userCreation}
                onChange={async (e) => {
                  handleChangeUserCreation(e.target.value);
                }}
              >
                <MenuItem value={"disabled"}>
                  {i18n.t("settings.settings.options.disabled")}
                </MenuItem>
                <MenuItem value={"enabled"}>
                  {i18n.t("settings.settings.options.enabled")}
                </MenuItem>
              </Select>
              <FormHelperText>
                {loadingUserCreation &&
                  i18n.t("settings.settings.options.updating")}
              </FormHelperText>
            </FormControl>
) },
{ id: "rating", group: "atendimento", title: "Avaliações de atendimento", description: "Controla a avaliação enviada após a conclusão de um atendimento.", icon: "StarBorder", visible: true, field: (
<FormControl className={classes.selectContainer}>
            <InputLabel id="ratings-label">{i18n.t("settings.settings.options.evaluations")}</InputLabel>
            <Select
              labelId="ratings-label"
              value={userRating}
              onChange={async (e) => {
                handleChangeUserRating(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingUserRating && i18n.t("settings.settings.options.evaluations")}
            </FormHelperText>
          </FormControl>
) },
{ id: "schedule", group: "expediente", title: "Horário de funcionamento", description: "Define o tratamento fora do horário de expediente.", icon: "AccessTime", visible: true, field: (
<FormControl className={classes.selectContainer}>
            <InputLabel id="schedule-type-label">
              {i18n.t("settings.settings.options.officeScheduling")}
            </InputLabel>
            <Select
              labelId="schedule-type-label"
              value={scheduleType}
              onChange={async (e) => {
                handleScheduleType(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>{i18n.t("settings.settings.options.disabled")}</MenuItem>
             <MenuItem value={"queue"}>{i18n.t("settings.settings.options.queueManagement")}</MenuItem>
              <MenuItem value={"company"}>{i18n.t("settings.settings.options.companyManagement")}</MenuItem> 
              <MenuItem value={"connection"}>{i18n.t("settings.settings.options.connectionManagement")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingScheduleType && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
) },
{ id: "greeting", group: "automaticas", title: "Saudação ao aceitar atendimento", description: "Envio automático quando o atendente aceita um ticket.", icon: "ChatBubbleOutline", visible: true, field: (
<FormControl className={classes.selectContainer}>
            <InputLabel id="sendGreetingAccepted-label">
              {i18n.t("settings.settings.options.sendGreetingAccepted")}
            </InputLabel>
            <Select
              labelId="sendGreetingAccepted-label"
              value={SendGreetingAccepted}
              onChange={async (e) => {
                handleSendGreetingAccepted(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingSendGreetingAccepted && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
) },
{ id: "random", group: "atendimento", title: "Distribuição aleatória", description: "Escolhe automaticamente um atendente quando habilitado.", icon: "Shuffle", visible: true, field: (
<FormControl className={classes.selectContainer}>
            <InputLabel id="userRandom-label">
              {i18n.t("settings.settings.options.userRandom")}
            </InputLabel>
            <Select
              labelId="userRandom-label"
              value={UserRandom}
              onChange={async (e) => {
                handleUserRandom(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingUserRandom && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
) },
{ id: "transfer", group: "tickets", title: "Mensagem na transferência", description: "Envio automático durante a transferência de setor ou atendente.", icon: "SwapHoriz", visible: true, field: (
<FormControl className={classes.selectContainer}>
            <InputLabel id="sendMsgTransfTicket-label">
              {i18n.t("settings.settings.options.sendMsgTransfTicket")}
            </InputLabel>
            <Select
              labelId="sendMsgTransfTicket-label"
              value={SettingsTransfTicket}
              onChange={async (e) => {
                handleSettingsTransfTicket(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingSettingsTransfTicket && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
) },
{ id: "bot", group: "geral", title: "Tipo do bot", description: "Formato das respostas utilizadas pelo bot.", icon: "Memory", visible: true, field: (
<FormControl className={classes.selectContainer}>
            <InputLabel id="schedule-type-label">{i18n.t("settings.settings.options.chatBotType")}</InputLabel>
            <Select
              labelId="schedule-type-label"
              value={chatBotType}
              onChange={async (e) => {
                handleChatBotType(e.target.value);
              }}
            >
              <MenuItem value={"text"}>Texto</MenuItem>
              {/* <MenuItem value={"button"}>{i18n.t("settings.settings.options.buttons")}</MenuItem>
              <MenuItem value={"list"}>Lista</MenuItem> */}
            </Select>
            <FormHelperText>
              {loadingScheduleType && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
) },
{ id: "calls", group: "chamadas", title: "Tratamento de chamadas no WhatsApp", description: "Define como lidar com chamadas recebidas pela conexão.", icon: "CallOutlined", visible: true, field: (
<FormControl className={classes.selectContainer}>
            <InputLabel id="acceptCallWhatsapp-label">
              Tratamento de chamadas no WhatsApp
            </InputLabel>
            <Select
              labelId="acceptCallWhatsapp-label"
              value={AcceptCallWhatsapp}
              onChange={async (e) => {
                handleAcceptCallWhatsapp(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>Desabilitado</MenuItem>
              <MenuItem value={"enabled"}>Somente enviar mensagem automática</MenuItem>
              <MenuItem value={"reject_message"}>Recusar chamada e enviar mensagem</MenuItem>
            </Select>
            <FormHelperText>
              {loadingAcceptCallWhatsapp
                ? i18n.t("settings.settings.options.updating")
                : "Configuração individual da empresa. Para recusar, preencha antes a mensagem abaixo."}
            </FormHelperText>
          </FormControl>
) },
{ id: "signature", group: "atendimento", title: "Assinatura do atendente", description: "Permite escolher o envio da assinatura nas mensagens.", icon: "CreateOutlined", visible: true, field: (
<FormControl className={classes.selectContainer}>
            <InputLabel id="sendSignMessage-label">
              {i18n.t("settings.settings.options.sendSignMessage")}
            </InputLabel>
            <Select
              labelId="sendSignMessage-label"
              value={sendSignMessage}
              onChange={async (e) => {
                handleSendSignMessage(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingSendSignMessage && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
) },
{ id: "queueGreeting", group: "fila", title: "Saudação com fila única", description: "Controla a saudação quando existe somente uma fila.", icon: "ForumOutlined", visible: true, field: (
<FormControl className={classes.selectContainer}>
            <InputLabel id="sendGreetingMessageOneQueues-label">
              {i18n.t("settings.settings.options.sendGreetingMessageOneQueues")}
            </InputLabel>
            <Select
              labelId="sendGreetingMessageOneQueues-label"
              value={sendGreetingMessageOneQueues}
              onChange={async (e) => {
                handleSendGreetingMessageOneQueues(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingSendGreetingMessageOneQueues && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
) },
{ id: "queuePosition", group: "fila", title: "Informar posição na fila", description: "Envia a posição do cliente durante a espera.", icon: "FormatListNumbered", visible: true, field: (
<FormControl className={classes.selectContainer}>
            <InputLabel id="sendQueuePosition-label">
              {i18n.t("settings.settings.options.sendQueuePosition")}
            </InputLabel>
            <Select
              labelId="sendQueuePosition-label"
              value={sendQueuePosition}
              onChange={async (e) => {
                handleSendQueuePosition(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingSendQueuePosition && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
) },
{ id: "farewell", group: "automaticas", title: "Despedida no aguardando", description: "Configura a mensagem de despedida ao mudar para aguardando.", icon: "ChatBubbleOutline", visible: true, field: (
<FormControl className={classes.selectContainer}>
            <InputLabel id="sendFarewellWaitingTicket-label">
              {i18n.t("settings.settings.options.sendFarewellWaitingTicket")}
            </InputLabel>
            <Select
              labelId="sendFarewellWaitingTicket-label"
              value={sendFarewellWaitingTicket}
              onChange={async (e) => {
                handleSendFarewellWaitingTicket(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingSendFarewellWaitingTicket && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
) },
{ id: "acceptAudio", group: "chamadas", title: "Recebimento de áudios", description: "Aceitar ou não mensagens de áudio recebidas no WhatsApp.", icon: "MicNone", visible: true, field: (
<FormControl className={classes.selectContainer}>
            <InputLabel id="acceptAudioMessageContact-label">
              {i18n.t("settings.settings.options.acceptAudioMessageContact")}
            </InputLabel>
            <Select
              labelId="acceptAudioMessageContact-label"
              value={acceptAudioMessageContact}
              onChange={async (e) => {
                handleAcceptAudioMessageContact(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingAcceptAudioMessageContact && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
) },
{ id: "requiredTag", group: "tickets", title: "Etiqueta obrigatória", description: "Exige uma etiqueta para encerrar o atendimento.", icon: "LocalOfferOutlined", visible: true, field: (
<FormControl className={classes.selectContainer}>
            <InputLabel id="requiredTag-label"> {i18n.t("settings.settings.options.requiredTag")}</InputLabel>
            <Select
              labelId="requiredTag-label"
              value={requiredTag}
              onChange={async (e) => {
                handleRequiredTag(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>{i18n.t("settings.settings.options.disabled")}</MenuItem>
              <MenuItem value={"enabled"}>{i18n.t("settings.settings.options.enabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingRequiredTag && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
) },
{ id: "closeTransfer", group: "tickets", title: "Fechamento ao transferir", description: "Define se a transferência para outro setor encerra o ticket.", icon: "CheckCircleOutline", visible: true, field: (
<FormControl className={classes.selectContainer}>
            <InputLabel id="closeTicketOnTransfer-label"> {i18n.t("settings.settings.options.closeTicketOnTransfer")}</InputLabel>
            <Select
              labelId="closeTicketOnTransfer-label"
              value={closeTicketOnTransfer}
              onChange={async (e) => {
                handleCloseTicketOnTransfer(e.target.value);
              }}
            >
              <MenuItem value={false}>{i18n.t("settings.settings.options.disabled")}</MenuItem>
              <MenuItem value={true}>{i18n.t("settings.settings.options.enabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingCloseTicketOnTransfer && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
) },
{ id: "notifyPending", group: "notificacoes", title: "Notificações de pendências", description: "Exibe avisos de tickets pendentes.", icon: "NotificationsNone", visible: true, field: (
<FormControl className={classes.selectContainer}>
            <InputLabel id="showNotificationPending-label"> {i18n.t("settings.settings.options.showNotificationPending")}</InputLabel>
            <Select
              labelId="showNotificationPending-label"
              value={showNotificationPending}
              onChange={async (e) => {
                handleShowNotificationPending(e.target.value);
              }}
            >
              <MenuItem value={false}>{i18n.t("settings.settings.options.disabled")}</MenuItem>
              <MenuItem value={true}>{i18n.t("settings.settings.options.enabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingShowNotificationPending && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
) },
{ id: "lgpdWelcome", group: "lgpd", title: "Mensagem de privacidade", description: "Texto inicial para informações de LGPD.", icon: "DescriptionOutlined", visible: enableLGPD === "enabled", field: (
<FormControl className={classes.selectContainer}>
                <TextField
                  id="lgpdMessage"
                  name="lgpdMessage"
                  margin="dense"
                  multiline
                  rows={3}
                  label={i18n.t("settings.settings.LGPD.welcome")}
                  variant="outlined"
                  value={lgpdMessage}
                  onChange={async (e) => {
                    handleLGPDMessage(e.target.value);
                  }}
                >
                </TextField>
                <FormHelperText>
                  {loadinglgpdMessage && i18n.t("settings.settings.options.updating")}
                </FormHelperText>
              </FormControl>
) },
{ id: "lgpdLink", group: "lgpd", title: "Link da política de privacidade", description: "Endereço da política de privacidade.", icon: "Link", visible: enableLGPD === "enabled", field: (
<FormControl className={classes.selectContainer}>
                <TextField
                  id="lgpdLink"
                  name="lgpdLink"
                  margin="dense"
                  label={i18n.t("settings.settings.LGPD.linkLGPD")}
                  variant="outlined"
                  value={lgpdLink}
                  onChange={async (e) => {
                    handleLGPDLink(e.target.value);
                  }}
                >
                </TextField>
                <FormHelperText>
                  {loadingLGPDLink && i18n.t("settings.settings.options.updating")}
                </FormHelperText>
              </FormControl>
) },
{ id: "lgpdDelete", group: "lgpd", title: "Exclusão de mensagens", description: "Tratamento de mensagens excluídas pelo contato.", icon: "DeleteOutline", visible: enableLGPD === "enabled", field: (
<FormControl className={classes.selectContainer}>
                <InputLabel id="lgpdDeleteMessage-label">{i18n.t("settings.settings.LGPD.obfuscateMessageDelete")}</InputLabel>
                <Select
                  labelId="lgpdDeleteMessage-label"
                  value={lgpdDeleteMessage}
                  onChange={async (e) => {
                    handleLGPDDeleteMessage(e.target.value);
                  }}
                >
                  <MenuItem value={"disabled"}>{i18n.t("settings.settings.LGPD.disabled")}</MenuItem>
                  <MenuItem value={"enabled"}>{i18n.t("settings.settings.LGPD.enabled")}</MenuItem>
                </Select>
                <FormHelperText>
                  {loadingLGPDDeleteMessage && i18n.t("settings.settings.options.updating")}
                </FormHelperText>
              </FormControl>
) },
{ id: "lgpdConsent", group: "lgpd", title: "Solicitação de consentimento", description: "Regras para consentimento no tratamento dos dados.", icon: "HowToReg", visible: enableLGPD === "enabled", field: (
<FormControl className={classes.selectContainer}>
                <InputLabel id="lgpdConsent-label">
                  {i18n.t("settings.settings.LGPD.alwaysConsent")}
                </InputLabel>
                <Select
                  labelId="lgpdConsent-label"
                  value={lgpdConsent}
                  onChange={async (e) => {
                    handleLGPDConsent(e.target.value);
                  }}
                >
                  <MenuItem value={"disabled"}>{i18n.t("settings.settings.LGPD.disabled")}</MenuItem>
                  <MenuItem value={"enabled"}>{i18n.t("settings.settings.LGPD.enabled")}</MenuItem>
                </Select>
                <FormHelperText>
                  {loadingLGPDConsent && i18n.t("settings.settings.options.updating")}
                </FormHelperText>
              </FormControl>
) },
{ id: "lgpdPhone", group: "lgpd", title: "Ocultar número de telefone", description: "Proteção dos dados exibidos aos atendentes.", icon: "VisibilityOff", visible: enableLGPD === "enabled", field: (
<FormControl className={classes.selectContainer}>
                <InputLabel id="lgpdHideNumber-label">
                  {i18n.t("settings.settings.LGPD.obfuscatePhoneUser")}
                </InputLabel>
                <Select
                  labelId="lgpdHideNumber-label"
                  value={lgpdHideNumber}
                  onChange={async (e) => {
                    handleLGPDHideNumber(e.target.value);
                  }}
                >
                  <MenuItem value={"disabled"}>{i18n.t("settings.settings.LGPD.disabled")}</MenuItem>
                  <MenuItem value={"enabled"}>{i18n.t("settings.settings.LGPD.enabled")}</MenuItem>
                </Select>
                <FormHelperText>
                  {loadingLGPDHideNumber && i18n.t("settings.settings.options.updating")}
                </FormHelperText>
              </FormControl>
) },
{ id: "messageTransfer", group: "personalizadas", title: "Mensagem de transferência", description: "Personalize a comunicação enviada ao transferir um atendimento.", icon: "SwapHoriz", visible: true, field: (
<FormControl className={classes.selectContainer}>
            <TextField
              id="transferMessage"
              name="transferMessage"
              margin="dense"
              multiline
              rows={3}
              label={i18n.t("settings.settings.customMessages.transferMessage")}
              variant="outlined"
              value={transferMessage}
              required={SettingsTransfTicket === "enabled"}
              onChange={async (e) => {
                handletransferMessage(e.target.value);
              }}
            >
            </TextField>
            <FormHelperText>
              {loadingTransferMessage && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
) },
{ id: "messageGreeting", group: "personalizadas", title: "Mensagem de saudação", description: "Texto enviado automaticamente na aceitação do atendimento.", icon: "ChatBubbleOutline", visible: true, field: (
<FormControl className={classes.selectContainer}>
            <TextField
              id="greetingAcceptedMessage"
              name="greetingAcceptedMessage"
              margin="dense"
              multiline
              rows={3}
              label={i18n.t("settings.settings.customMessages.greetingAcceptedMessage")}
              variant="outlined"
              value={greetingAcceptedMessage}
              required={SendGreetingAccepted === "enabled"}
              onChange={async (e) => {
                handleGreetingAcceptedMessage(e.target.value);
              }}
            >
            </TextField>
            <FormHelperText>
              {loadingGreetingAcceptedMessage && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
) },
{ id: "messageCalls", group: "personalizadas", title: "Resposta para chamadas", description: "Texto enviado ao cliente conforme a opção de chamadas.", icon: "CallOutlined", visible: true, field: (
<FormControl className={classes.selectContainer}>
            <TextField
              id="AcceptCallWhatsappMessage"
              name="AcceptCallWhatsappMessage"
              margin="dense"
              multiline
              rows={3}
              label={i18n.t("settings.settings.customMessages.AcceptCallWhatsappMessage")}
              variant="outlined"
              required={AcceptCallWhatsapp === "reject_message"}
              value={AcceptCallWhatsappMessage}
              inputProps={{ maxLength: 2000 }}
              onChange={(e) => setAcceptCallWhatsappMessage(e.target.value)}
              onBlur={(e) => {
                // Evita chamar a Evolution a cada caractere digitado.
                if (e.target.value !== (settings.AcceptCallWhatsappMessage || "")) {
                  handleAcceptCallWhatsappMessage(e.target.value);
                }
              }}
            >
            </TextField>
            <FormHelperText>
              {loadingAcceptCallWhatsappMessage && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
) },
{ id: "messageQueue", group: "personalizadas", title: "Mensagem da posição na fila", description: "Texto utilizado para informar a posição de espera.", icon: "FormatListNumbered", visible: true, field: (
<FormControl className={classes.selectContainer}>
            <TextField
              id="sendQueuePositionMessage"
              name="sendQueuePositionMessage"
              margin="dense"
              multiline
              required={sendQueuePosition === "enabled"}
              rows={3}
              label={i18n.t("settings.settings.customMessages.sendQueuePositionMessage")}
              variant="outlined"
              value={sendQueuePositionMessage}
              onChange={async (e) => {
                handlesendQueuePositionMessage(e.target.value);
              }}
            >
            </TextField>
            <FormHelperText>
              {loadingSendQueuePositionMessage && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
) }
  ];
  const overviewIds = ["creation", "rating", "random", "calls", "requiredTag", "signature", "notifyPending", "messageTransfer", "messageGreeting", "queuePosition", "bot", "schedule"];
  const displayedFields = allFields.filter((field) => field.visible &&
    (normalizedTerm
      ? `${field.title} ${field.description} ${(SETTINGS_CATEGORIES.find((item) => item.id === field.group) || {}).title || ""}`
        .toLocaleLowerCase("pt-BR").includes(normalizedTerm)
      : selectedCategory === "geral" ? overviewIds.includes(field.id) : field.group === selectedCategory));

  return (
    <div className={classes.shell}>
      <nav className={classes.sidebar} aria-label="Categorias das configurações">
        {availableCategories.map((item) => (
          <button
            type="button"
            key={item.id}
            className={`${classes.sideItem} ${selectedCategory === item.id && !normalizedTerm ? classes.sideActive : ""}`}
            aria-current={selectedCategory === item.id && !normalizedTerm ? "page" : undefined}
            onClick={() => { setSelectedCategory(item.id); setSearchTerm(""); }}
          >
            <SettingIcon name={item.icon} className={classes.sideIcon} />
            <span>
              <span className={classes.sideTitle}>{item.title}</span>
              <span className={classes.sideSub}>{item.description}</span>
            </span>
          </button>
        ))}
      </nav>
      <main className={classes.body}>
        <div className={classes.toolbar}>
          <div>
            <Typography component="h2" className={classes.sectionName}>
              {normalizedTerm ? "Resultados da pesquisa" : category.title}
            </Typography>
            <Typography className={classes.sectionHint}>
              {normalizedTerm ? "Encontre e ajuste as opções disponíveis nesta empresa." : category.description}
            </Typography>
          </div>
          <TextField
            className={classes.search}
            variant="outlined"
            size="small"
            placeholder="Buscar configuração..."
            value={searchTerm}
            onChange={(event) => setSearchTerm(event.target.value)}
            inputProps={{ "aria-label": "Buscar configurações" }}
            InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon color="action" fontSize="small" /></InputAdornment> }}
          />
        </div>
        <div className={classes.info}>
          <CheckCircleOutlineIcon style={{ fontSize: 16, color: "#16a34a" }} />
          Cada opção continua sendo salva automaticamente, como antes.
        </div>
        {displayedFields.length > 0 ? (
          <div className={classes.grid}>
            {displayedFields.map((field) => (
              <section key={field.id} className={classes.card} aria-label={field.title}>
                <div className={classes.cardHead}>
                  <span className={classes.iconFrame}><SettingIcon name={field.icon} /></span>
                  <div>
                    <Typography component="h3" className={classes.fieldTitle}>{field.title}</Typography>
                    <Typography className={classes.fieldSubtitle}>{field.description}</Typography>
                  </div>
                </div>
                <div className={classes.control}>{field.field}</div>
              </section>
            ))}
          </div>
        ) : (
          <div className={classes.empty}>Nenhuma configuração encontrada. Tente outra pesquisa ou categoria.</div>
        )}
        <div className={classes.footer}>
          <CheckCircleOutlineIcon style={{ color: "#16a34a", fontSize: 19 }} />
          Alterações salvas automaticamente ao mudar cada campo
        </div>
      </main>
    </div>
  );
}
